const CONSTANTS = require('frontend-controller/lib/constants')

module.exports = {
    config: {
        renderingSubTreeConditionally: true, // skips some error messages (e.g., used for inclusion actions which cannot find the parent during the render process)
    },

    model: {
        ninjaModule: '',            // actual ninjaModule (e.g., news)
        ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)
        ninjaModuleSubConfig: {},   // actual ninjaModuleSubConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news.entityPart.coreInformation)

        entityPartID: null,         // actual entityPartID (e.g., cms_newsParts.newsPartID)
        routeID: null,              // actual routeID
        langCode: '',               // actual langCode

        autoCreate: false,          // autoCreate granted?
        recordFound: false,         // has a record be found?
    },

    events: {
        addNinja: {
            type: 'click',
            selector: 'button',
            action: function(event){
                const self = event.data.component
                const $target = $(event.target)
                if($target.length > 0){
                    const fieldType = $target.data('fieldType')
                    if(fieldType === 'addNinjaRoute'){
                        self.addNinjaRoute()
                    }
                }
            }
        }
    },

    methods: {
        isBuildGranted(storage){
            if(storage.isServer){
                return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
            }

            const langCode = this.model.langCode = this.getResourceRegisterContent('entityPartLangCode')

            this.closest('templates_ninja_controller', controller => {
                const {
                    ninjaModule,
                    ninjaModuleConfig
                } = controller.getNinjaModuleParams()
                this.model.ninjaModule = ninjaModule
                this.model.ninjaModuleConfig = ninjaModuleConfig
            }, true)
            this.closest('templates_ninja_entityController', controller => {
                const {
                    entityPartID,
                    routeID,
                } = controller.getPartState(langCode)
                this.model.entityPartID = entityPartID
                this.model.routeID = routeID
            }, true)

            const ninjaModuleConfig = this.model.ninjaModuleConfig || {}
            const ninjaModuleSubConfig = this.model.ninjaModuleSubConfig = (ninjaModuleConfig.entityPart || {}).route

            if(ninjaModuleSubConfig){
                const turnedOn = ninjaModuleConfig.turnedOn && ninjaModuleSubConfig.turnedOn

                if(turnedOn && this.model.entityPartID){
                    this.model.autoCreate = ninjaModuleSubConfig.autoCreate
                    this.model.recordFound = !!this.model.routeID

                    return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
                }
            } else {
                console.error(`ninjaModuleSubConfig missing: frontend-controller/client/appConfig.js ninjaModules.${this.model.ninjaModule}.entityPart.route`)
            }

            this.closest('base_tabStrip_tabContent', tabContent => {
                tabContent.close()
            })

            return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO
        },

        /**
         * creates a route-entry.
         */
        async addNinjaRoute(){
            let partPropertiesForm, activeRegisterSecret
            this.locate('< base_tabStrip_tabStrip > templates_ninja_partPropertiesForm', c => partPropertiesForm = c)
            this.locate('< base_tabStrip_tabStrip', c => activeRegisterSecret = c.model.activeRegisterSecret)
            if(partPropertiesForm){
                partPropertiesForm.model.startWithRegisterSecret = activeRegisterSecret
                await partPropertiesForm.ensureRoute(true)
                await partPropertiesForm.submit()
                partPropertiesForm.model.startWithRegisterSecret = null
            }
        },
    },

    handlers: [
        {
            name: 'afterCancel',
            componentClass: 'templates_propertiesForms_routePropertiesForm',
            handle: function(callerComponent){
                // check if the caller is the child of this ninja-gatekeeper-route
                callerComponent.closest('templates_ninja_gatekeeper_route', gatekeeper => {
                    if(gatekeeper.componentIndex === this.componentIndex){
                        this.closest('base_tabStrip_tabContent', tabContent => {
                            tabContent.refresh()
                        })
                    }
                })
            }
        },
        {
            name: 'onSubmitDone',
            componentClass: 'templates_propertiesForms_routePropertiesForm',
            handle: function(callerComponent, nodeData, insertPerformed, options){
                // check if the caller is the child of this ninja-gatekeeper-route
                callerComponent.closest('templates_ninja_gatekeeper_route', gatekeeper => {
                    if(gatekeeper.componentIndex === this.componentIndex){
                        this.refresh()
                    }
                }, true)
            }
        }
    ]
}
